import { render, staticRenderFns } from "./data-statistics.vue?vue&type=template&id=4f4bae47&scoped=true"
import script from "./data-statistics.vue?vue&type=script&lang=js"
export * from "./data-statistics.vue?vue&type=script&lang=js"
import style0 from "./data-statistics.vue?vue&type=style&index=0&id=4f4bae47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4bae47",
  null
  
)

export default component.exports